/** @jsxImportSource @emotion/react */

import React from 'react';
import PageTemplate from '@page/iyagigo/page-template';
import VocabularyBookReview from '@component/iyagigo/vocabulary-book/vocabulary-book-review';
import { useTypedDispatch, useTypedSelector } from '@hook/common/useStore';
import { actions as modalActions } from '@store/slice/modal-slice';
import * as color from '@constant/color';
import { TIyagigoSubMenu } from '@datatype/iyagigo/type';

// Phase 2: 회독 모드 본격 구현 시 vocabularyBookKey/단어 데이터 백엔드 연동 추가
const VocabularyBookReviewPage: React.FC<any> = () => {
  const dispatch = useTypedDispatch();
  const vocabularyBookSubMenu = useTypedSelector(
    (state) => state.rootReducer?.navigationReducer?.iyagigo?.subMenu,
  ) as TIyagigoSubMenu['vocabulary-book'];

  const handleBackClick = () => {
    dispatch(
      modalActions.showDialogModal({
        type: 'workbook-quit',
        data: {
          mainMenu: 'vocabulary-book',
          // 현재 학습 중인 subMenu(시험준비/일반학습) 보존하여 vocabulary-book-home의 탭 유지
          subMenu: vocabularyBookSubMenu ?? undefined,
        },
      }),
    );
  };

  return (
    <PageTemplate
      title='회독'
      mode='close'
      backgroundColor={color.GRAY_BACKGROUND_COLOR}
      handleNavigationClick={handleBackClick}>
      <VocabularyBookReview />
    </PageTemplate>
  );
};

export default VocabularyBookReviewPage;
